var exports = {
  "k": "xf0b3b88a--70f381--container",
  "K": "xf0b3b88a--70f381--icon",
};

module.exports = exports;
